const LoadingState = ({ rows = 3 }) => (
  <div className="w-full flex flex-col gap-3 animate-pulse">
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        className="h-2.5 rounded-full bg-black/[0.06] dark:bg-white/[0.07]"
        style={{ width: `${85 - i * 12}%` }}
      />
    ))}
  </div>
);
var LoadingState_default = LoadingState;
export { LoadingState_default as default };